import * as React from "react";
import { P, H1, Content } from "../recurso_literario.js";

export const Project = (props)=>{
    return (
	<Content>
		<H1> Proyectos </H1>

		<P>
			Los proyectos son agrupaciones de elementos dentro de una Nube. Te permiten
			tener organizados los elementos de la nube bajo algún criterio. Por ejemplo, 
			por área o servicio o proyecto.
		</P>

		<h2> Seleccionar el proyecto en cual trabajar </h2>

		<P>
			En la parte superior de la pantalla, la plataforma te indicará en qué proyecto te
			encuentras actualmente.
		</P>

		<P>
			<img src="/img/Proyect/Proyect1.png" alt="Cambiar de proyecto"/>
		</P>

		<P>
			Del mismo podrás desplegar el selector de proyectos y cambiar a otro proyecto.
			Se listarán solo los proyectos a los que tienes acceso así que si no aparece el
			proyecto que deseabas en el listado es porque le faltan permisos a tu usuario.
		</P>

		<h2> Listar mis proyectos y gestionarlos </h2>

		<P>
			Para listar y gestionar los proyectos de tu nube, debes dirigirte en el menú de la
			izquierda a Gestión {">"} Proyectos.
		</P>

		<P>
			<img src="/img/Gestion/GProjects/GProjects_Button.PNG"
				 alt="Boton Proyectos" />
		</P>

		<P>
			El listado de proyectos se muestra a continuación
		</P>

		<P>
			<img src="/img/Proyect/Proyect2.png" alt="Cambiar de proyecto" style={{width:"880px"}}/>
		</P>

			Accederás a un listado de todos los proyectos que existen en tu nube.

		<h2> Agregar un Proyecto </h2>

		<P>
			Para agregar un proyecto necesitas darle clic al botón Agregar en la esquina superior
			izquierda del Listado de Proyectos. Se te pedirá el nombre del nuevo Proyecto.
		</P>

		<P>
			<img src="/img/Proyect/Proyect3.png" alt="Alta de proyecto"/>
		</P>

		<h2> Ver los detalles de un proyecto </h2>

		<P>
			Podrás ver los detalles de un proyecto y gestionar el mismo seleccionandolo del listado.
			La siguiente información aparecerá en pantalla indicándote cuantos elementos tenés en tu
			nube y cuantos de ellos en el proyecto que seleccionaste.
		</P>

		<P>
			<img src="/img/Detalles/DResumen.PNG" alt="Detalle proyecto"/>
		</P>

		<P>
			<img src="/img/Proyect/Proyect5.png" alt="Detalle proyecto"/>
		</P>

		<h2> Eliminación de proyecto </h2>

		<P>
			Podrás eliminar un proyecto desde la pantalla de detalles del mismo. Para eliminarlo
			simplemente presiona el botón eliminar que se encuentra en la barra inferior de acciones.
		</P>

		<P>
			<img src="/img/Proyect/Proyect_delete.png" alt="Eliminar proyecto"/>
		</P>

		<P>
			Una vez dado clic en el botón Eliminar se abrirá una ventana de confirmación.
		</P>

		<P>
			<img src="/img/Gestion/GProjects/GProjects_AlertDeleteProject.PNG" alt="Alerta Eliminar Proyecto"/>
		</P>

		<P>
			La plataforma no te permitirá eliminar un proyecto si éste tiene elementos. Deberás
			eliminar o mover los elementos hasta que el proyecto quede vacío para poder eliminarlo.
		</P>

		<h2> Mover elementos entre proyectos </h2>

		<P>
			Los elementos pueden moverse entre proyectos siempre y cuando tengas los permisos
			suficientes para hacerlos con el usuario con el que te encuentras autenticado.
			Hay elementos que al moverlos se lleva con él otros elementos. Por ejemplo, las VM.
			Si mueves una VM de un “proyecto A” al “proyecto B”, los discos e IP Públicas que
			tengas asignadas a dicha VM se moverán junto con la VM.
		</P>

		<P>
			Para mover un elemento de un proyecto a otro debes ir al elemento y buscar el siguiente
			botón de acción en la barra inferior
		</P>

		<P>
			<img src="/img/Proyect/Proyect_mover.png" alt="Cambiar de proyecto"/>
		</P>



	</Content>
	)
}
